import { Button, Typography } from '@mui/material';
import { Upload, Visibility } from '@mui/icons-material';
import React, { useState } from 'react';
import ImageLightbox from './ImageLightBox';
import useIsMobile from '@hooks/useIsMobile';

type InsuranceCardProps = {
  _id: string;
  insuredID?: string;
  insuranceCarrier?: string;
  frontPhoto?: any;
  backPhoto?: any;
  index: number;
  onEditCard: (id: string) => void;
  onDeleteCard: (index: number) => void;
};

const InsuranceCard = ({
  _id,
  insuredID = '',
  insuranceCarrier = '',
  frontPhoto,
  backPhoto,
  index,
  onEditCard,
  onDeleteCard,
}: InsuranceCardProps) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxStartIndex, setLightboxStartIndex] = useState(0);
  const isMobile = useIsMobile();

  let maxLength = window.innerWidth <= 767 ? 10 : 18;

  let carrier =
    insuranceCarrier.length > maxLength
      ? `${insuranceCarrier.substring(0, maxLength).trim()}...`
      : insuranceCarrier;


  const checkForPhotos = Boolean(frontPhoto) && Boolean(backPhoto);

  return (
    <div className="card-container" key={_id}>
      <div className={`card`} id={_id}>
        <div className="top-half">
          <div className="card-details">
            <p>{carrier !== '' ? carrier : 'Unknown Carrier'}</p>
            <p>{insuredID !== '' ? insuredID : 'Unknown ID'}</p>
          </div>

          <div className="card-button-stack">
            <Button
              variant="contained"
              className="grey-btn"
              onClick={() => {
                onEditCard(_id);
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 100);
              }}
            >
              Edit
            </Button>
            <Button
              variant="contained"
              className="grey-btn"
              onClick={() => onDeleteCard(index)}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="bottom-half">
          {checkForPhotos ? (
            <div className="card-images">
              {/* FRONT */}
              <div className="image-container">
                {frontPhoto && (
                  <img
                    src={frontPhoto}
                    loading="lazy"
                    alt="Front of insurance card"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: 8,
                    }}
                  />
                )}
                <div
                  className="cta"
                  onClick={() => {
                    setLightboxStartIndex(0);
                    setLightboxOpen(true);
                  }}
                >
                  <Visibility className="icon" />
                  <Typography variant="body2">View</Typography>
                </div>
              </div>

              {/* BACK */}
              <div className="image-container">
                {backPhoto && (
                  <img
                    src={backPhoto}
                    loading="lazy"
                    alt="Back of insurance card"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: 8,
                    }}
                  />
                )}
                <div
                  className="cta"
                  onClick={() => {
                    setLightboxStartIndex(1);
                    setLightboxOpen(true);
                  }}
                >
                  <Visibility className="icon" />
                  <Typography variant="body2">View</Typography>
                </div>
              </div>
            </div>
          ) : (
            <button
              className="upload-cta"
              onClick={() => {
                onEditCard(_id);
                setTimeout(() => {
                  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                }, 100);
              }}
            >
              <Upload className="upload-icon" />
              Upload Insurance Card Images
            </button>
          )}
        </div>
      </div>

      <ImageLightbox
        open={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        images={[frontPhoto, backPhoto]}
        startIndex={lightboxStartIndex}
      />
    </div>
  );
};

export default InsuranceCard;